// @flow
// SHARED LINKS SETTINGS CONSTANTS
export const LOAD_FILE_REQUEST_DATA = "LOAD_FILE_REQUEST_DATA";
export const SET_MESSAGE_SETTINGS = "SET_MESSAGE_SETTINGS";
export const SET_LIMIT_SETTINGS = "SET_LIMIT_SETTINGS";
export const SET_EXPIRES_SETTINGS = "SET_EXPIRES_SETTINGS";
